import { render, staticRenderFns } from "./ProfileFilterChildren.vue?vue&type=template&id=7b891a7c&scoped=true&"
import script from "./ProfileFilterChildren.vue?vue&type=script&lang=ts&"
export * from "./ProfileFilterChildren.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileFilterChildren.vue?vue&type=style&index=0&id=7b891a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b891a7c",
  null
  
)

export default component.exports